<template>
	<v-container grid-list-md>
		<v-card flat color="transparent" class="pa-0 ma-0">
			<v-card-title primary-title>
				{{ $t("title.pending_orders") }}
			</v-card-title>
			<v-card-subtitle>
				{{ $t("label.list_of_pending_orders") }}
			</v-card-subtitle>
			<v-card-text>
				<v-expansion-panels
					v-if="orders.length > 0"
					multiple
					v-model="panels"
				>
					<v-expansion-panel
						v-for="(order, index) in orders"
						:key="index"
					>
						<v-expansion-panel-header v-slot="{ open }">
							<OrderExpansionHeader
								:order="order"
								:open="open"
							></OrderExpansionHeader>
						</v-expansion-panel-header>
						<v-expansion-panel-content class="grey lighten-4">
							<v-container grid-list-xl>
								<v-layout row wrap>
									<v-flex xs12 md8>
										<v-layout row wrap>
											<v-flex xs12 v-if="order.address">
												<OrderDeliveryAddress
													:order="order"
												></OrderDeliveryAddress>
											</v-flex>
											<v-flex xs12 md12>
												<OrderItemsTable
													:order="order"
												></OrderItemsTable>
											</v-flex>
										</v-layout>
									</v-flex>
									<v-flex xs12 md4>
										<v-card>
											<v-card-text>
												<OrderSummary
													:order="order"
												></OrderSummary>
											</v-card-text>
											<v-card-actions class="d-flex">
												<div class="flex-grow-0">
													<DeclineOrderForm
														v-model="item"
														:order="order"
													></DeclineOrderForm>
												</div>
												<div>&nbsp;</div>
												<div class="flex-grow-1">
													<AcceptOrderForm
														:order="order"
													></AcceptOrderForm>
												</div>
											</v-card-actions>
										</v-card>
									</v-flex>
								</v-layout>
							</v-container>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
				<EmptyResultComponent v-else></EmptyResultComponent>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import OrderExpansionHeader from "@Shop/components/OrderExpansionHeader.vue";
import OrderItemsTable from "@Shop/components/OrderItemsTable.vue";
import OrderSummary from "@Shop/components/OrderSummary.vue";
import OrderDeliveryAddress from "@Shop/components/OrderDeliveryAddress.vue";
import EmptyResultComponent from "@Shop/components/EmptyResultComponent.vue";
import AcceptOrderForm from "@Shop/forms/AcceptOrderForm.vue";
import DeclineOrderForm from "@Shop/forms/DeclineOrderForm.vue";

export default {
	name: "PendingOrder",
	components: {
		OrderExpansionHeader,
		OrderItemsTable,
		OrderSummary,
		OrderDeliveryAddress,
		EmptyResultComponent,
		AcceptOrderForm,
		DeclineOrderForm,
	},

	props: ["orders"],

	data() {
		return {
			item: this.$inertia.form({
				cancel_reason: null,
				delivery_duration: null,
			}),
			dialog_declined: false,
			panels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
		};
	},
};
</script>